import { setCookie } from "../actions";
import type { AnalyticParamsType } from "../types";

export const setAnalyticsParam = (
  param: AnalyticParamsType,
  value: string,
): URLSearchParams => {
  const searchParams = new URLSearchParams(window.location.search);

  searchParams.set(param, value);

  setCookie(param, value);

  return searchParams;
};
